<template>

  <v-container grid-list-md>
    <v-layout row wrap  justify-center>

        <v-flex xs12 md5>

          <v-card to="/chooseroute"
            class="mx-auto"
            max-width="400"
          >
            <v-img
              class="white--text"
              height="180px"
              :src="require('@/assets/resources.jpg')"
            >
              <v-card-title class="align-end fill-height">Choose Your Route</v-card-title>
            </v-img>

            <!--v-card-actions>
                <v-btn text color="orange" to="/tools1">More info</v-btn>
            </v-card-actions-->
          </v-card>

        </v-flex>


        <v-flex xs12 md5>

          <v-card to="/list/ALL"
            class="mx-auto"
            max-width="400"
          >
            <v-img
              class="white--text"
              height="180px"
              :src="require('@/assets/new_to_flli.jpg')"
            >
              <v-card-title class="align-end fill-height">Find a Course</v-card-title>
            </v-img>

            <!--v-card-actions>
                <v-btn text color="orange" to="/list">More info</v-btn>
            </v-card-actions-->
          </v-card>

        </v-flex>


        <v-flex xs12 md5>

          <v-card to="/growskills"
            class="mx-auto"
            max-width="400"
          >
            <v-img
              class="white--text"
              height="180px"
              :src="require('@/assets/instructors.jpg')"
            >
              <v-card-title class="align-end fill-height">Grow Your Skills</v-card-title>
            </v-img>

            <!--v-card-actions>
                <v-btn text color="orange" to="/facilitators">More info</v-btn>
            </v-card-actions-->
          </v-card>

        </v-flex>


        <v-flex xs12 md5>

          <v-card to="/calendar"
            class="mx-auto"
            max-width="400"
          >
            <v-img
              class="white--text"
              height="180px"
              :src="require('@/assets/course_list.jpg')"
            >
              <v-card-title class="align-end fill-height">Choose a Date</v-card-title>
            </v-img>

            <!--v-card-actions>
                <v-btn text color="orange" to="/calendar">More info</v-btn>
            </v-card-actions-->
          </v-card>

        </v-flex>


        <v-flex xs12 md5>

          <v-card to="/lifecycle"
            class="mx-auto"
            max-width="400"
          >
            <v-img
              class="white--text"
              height="180px"
              :src="require('@/assets/wing_clouds_sun.jpg')"
            >
              <v-card-title class="align-end fill-height">Learning Lifecycle</v-card-title>
            </v-img>

            <!--v-card-actions>
                <v-btn text color="orange" to="/lifecycle">More info</v-btn>
            </v-card-actions-->
          </v-card>

        </v-flex>


        <v-flex xs12 md5>

          <v-card to="/slc"
            class="mx-auto"
            max-width="400"
          >
            <v-img
              class="white--text"
              height="180px"
              :src="require('@/assets/plane_engine_and_wheel.jpg')"
            >
              <v-card-title class="align-end fill-height">Leadership Capabilities</v-card-title>
            </v-img>

            <!--v-card-actions>
                <v-btn text color="orange" to="/slc">More info</v-btn>
            </v-card-actions-->
          </v-card>

        </v-flex>



    </v-layout>
  </v-container>

</template>

<script>
  export default {
    data () {
      return {
        image: require('@/assets/at_a_glance.jpg')
      }
    }
  }
</script>

<style>

</style>
